import { checkGlobalError } from '@/utils/checkPermissions.js';

export const checkError = async function({ status, resp, options = {} }) {
  const globalError = checkGlobalError.call(this, { status, resp, options });
  let lastInStack = false;
  if (globalError) {
    return globalError;
  } else if (status === 404) {
    if (resp.code === 80) {
      // suspended account
      try {
        await this.$store.dispatch('profile/getProfile');
        this.$store.dispatch('getAccountMetadata');
      } catch {
        this.$store.dispatch('logout');
      } finally {
        lastInStack = true;
        return true;
      }
    }
  }
  return lastInStack;
};
